import React, { useCallback, useContext, useEffect, useState } from 'react';
import { UsuarioLoginInterface } from '../interfaces/UsuarioLoginInterface';

type AuthContextProps = {
  token: string | null;
  usuario: UsuarioLoginInterface | null;
  rol: string | null;
  movimientoExternoId?: string;
  sistemaId?: string;
  isLoggedIn: boolean;
  login: (
    usuario: UsuarioLoginInterface | null,
    token: string | null,
    rol: string | null,
    movimiento_externo_id?: string,
    sistema_id?: string
  ) => void;
  logout: () => void;
  imagenPerfil: string;
};

export const AuthContext = React.createContext({} as AuthContextProps);

const retrieveStoredToken = () => {
  return localStorage.getItem('token');
};

const retrieveStoredRol = () => {
  return localStorage.getItem('rol');
};

const retrieveStoredUsuario = () => {
  let storedUsuario: UsuarioLoginInterface | null = null;
  if (localStorage.getItem('usuario')) {
    storedUsuario = JSON.parse(localStorage.getItem('usuario') || '{}');
  }
  return storedUsuario;
};

const retrieveStoredMovimientoExternoId = () => {
  return localStorage.getItem('movimientoExternoId');
};

const retrieveSistemaId = () => {
  return localStorage.getItem('sistemaId');
};

export const AuthContextProvider = ({ children }: any) => {
  const tokenData = retrieveStoredToken();
  const usuarioData = retrieveStoredUsuario();
  const rolData = retrieveStoredRol();
  const movimientoExternoIdData = retrieveStoredMovimientoExternoId();
  const sistemaIdData = retrieveSistemaId();

  let initialToken: string | null = tokenData || null;
  const [token, setToken] = useState<string | null>(initialToken);

  const userIsLoggedIn = !!token;

  let initialRol: string | null = rolData || null;
  const [rol, setRol] = useState<string | null>(initialRol);

  let initialUsuario: UsuarioLoginInterface | null = usuarioData || null;
  const [usuario, setUsuario] = useState<UsuarioLoginInterface | null>(initialUsuario);

  let initialMovimientoExternoId: string | undefined = movimientoExternoIdData || undefined;
  const [movimientoExternoId, setMovimientoExternoId] = useState<string | undefined>(initialMovimientoExternoId);

  let initialSistemaId: string | undefined = sistemaIdData || undefined;
  const [sistemaId, setSistemaId] = useState<string | undefined>(initialSistemaId);

  const logoutHandler = useCallback(() => {
    setToken(null);
    setUsuario(null);
    setRol(null);
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    localStorage.removeItem('rol');
    localStorage.removeItem('movimientoExternoId');
    localStorage.removeItem('sistemaId');
  }, []);

  const loginHandler = (
    usuario: UsuarioLoginInterface | null,
    token: string | null,
    rol: string | null,
    movimiento_externo_id?: string,
    sistema_id?: string
  ) => {
    setToken(token);
    if (token) {
      localStorage.setItem('token', token);
    }
    setRol(rol);
    if (rol) {
      localStorage.setItem('rol', rol);
    }
    setUsuario(usuario);
    if (usuario) {
      localStorage.setItem('usuario', JSON.stringify(usuario));
    }
    setMovimientoExternoId(movimiento_externo_id);
    if (movimiento_externo_id) {
      localStorage.setItem('movimientoExternoId', movimiento_externo_id);
    }
    setSistemaId(sistema_id);
    if (sistema_id) {
      localStorage.setItem('sistemaId', sistema_id);
    }
  };

  const getProfileImage = () => {
    return rol === "Administrador" ? "Admin.png" : usuario?.imagenPerfil || "User.png"; 
  };

  const contextValue = {
    token,
    rol,
    usuario,
    movimientoExternoId,
    sistemaId,
    isLoggedIn: userIsLoggedIn,
    login: loginHandler,
    logout: logoutHandler,
    imagenPerfil: getProfileImage(),
  };

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};